<picture>
  <source srcset="/assets/taustat/login_720x512_crushed.webp 720w, /assets/taustat/login_1440x1024_crushed.webp 1440w, /assets/taustat/login_2880x2048_crushed.webp 2880w, /assets/taustat/login_4320x3072_crushed.webp 4320w" type="image/webp" sizes="100vw" />
  <source srcset="/assets/taustat/login_720x512_crushed.png 720w, /assets/taustat/login_1440x1024_crushed.png 1440w, /assets/taustat/login_2880x2048_crushed.png 2880w, /assets/taustat/login_4320x3072_crushed.png 4320w" type="image/png" sizes="100vw" />
  <img src="/assets/taustat/login_720x512_crushed.png" class="tausta" />
</picture>

<div class="all-container">
  <mat-nav-list class="lang-select-list">
    <mat-list-item (click)="vaihdaKieli()">
      <div class="lang-select">
        Kieli /
        <!-- Språk /-->
        Language
      </div>
    </mat-list-item>
  </mat-nav-list>

  <div class="welcome-container">
    <div class="mat-elevation-z3 top-corners-rounded bottom-corners-rounded">
      <div class="top-corners-rounded" style="padding: 2px">
        <div class="valkoinen logo-container top-corners-rounded">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60%" viewBox="0 0 386 69">
            <defs>
              <path id="a" d="M.6.085h8.51v10.51H.6V.086z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
              <path fill="#FCEE21" d="M72.972 9.913c-14.683-13.328-38.454-13.2-53.095.286L4.444 24.414c-5.955 5.485-5.92 14.884.074 20.325l15.435 14.012c14.682 13.328 38.454 13.2 53.094-.285L88.481 44.25c5.954-5.485 5.92-14.884-.074-20.325L72.972 9.913z" />
              <path fill="#0E0E31" fill-opacity=".05" d="M73.046 58.465L88.479 44.25a13.697 13.697 0 0 0 4.348-8.532c-12.885 3.026-27.7 2.405-43.463 2.405-18.226 0-35.185.041-49.357-3.917a13.717 13.717 0 0 0 4.51 10.533L19.95 58.75c14.683 13.329 38.454 13.201 53.095-.285" />
              <path
                fill="#FFF"
                d="M65.347 42.165c2.095-.104 3.901-1.763 3.964-3.683.093-2.843.093-4.266 0-7.11-.063-1.92-1.869-3.578-3.964-3.682a442.7 442.7 0 0 0-39.863 0c-2.096.104-3.902 1.763-3.964 3.682-.094 2.844-.094 4.267 0 7.11.062 1.92 1.868 3.579 3.964 3.683 13.298.598 26.565.598 39.863 0M52.448 54.829c.151-3.422.274-6.839.37-10.262-5.093.093-10.175.09-15.267-.011.101 3.42.231 6.832.392 10.25.108 2.09 1.773 3.894 3.697 3.96 2.85.099 4.274.102 7.124.014 1.924-.059 3.583-1.859 3.684-3.951M52.817 25.288c-.095-3.423-.218-6.84-.369-10.262-.101-2.093-1.76-3.892-3.684-3.951-2.85-.088-4.275-.085-7.124.013-1.924.067-3.59 1.871-3.697 3.961-.16 3.418-.29 6.83-.392 10.25a402.96 402.96 0 0 1 15.266-.011"
              />
              <path fill="#FFF" d="M37.466 25.208l.13 21.113 15.239-1.635-.036-19.415-7.509-.923z" />
              <g>
                <path
                  fill="#FFF"
                  d="M296.599 33.996c-.207-2.533-1.265-4.736-3.051-6.564-2.786-2.852-7.262-3.571-11.512-3.571h-.003c-4.25 0-8.727.719-11.512 3.57-1.786 1.829-2.844 4.032-3.051 6.565-.439 5.379-.273 18.721-.273 18.721h4.701s3.716.145 3.716-4.128c0-3.907.013-9.415.013-11.095 0-6.306 5.326-6.372 6.408-6.372 1.08 0 6.407.066 6.407 6.372 0 2.693.02 5.389.02 8.083l.002.063c.008 3.887.066 7.077.066 7.077h4.625s3.714.145 3.714-4.128l.001-1.649c0-.004.003-.008.003-.013 0-5.531.164-7.552-.274-12.931M226.23 33.996c-.207-2.533-1.265-4.736-3.051-6.564-2.785-2.852-5.923-3.571-10.173-3.571h-.004c-3.848 0-8.293 1.518-10.665 4.914-2.49-3.396-6.818-4.914-10.665-4.914h-.004c-4.25 0-7.463.719-10.248 3.57-1.785 1.829-2.844 4.032-3.05 6.565-.44 5.379-.197 18.721-.197 18.721h4.625s3.715.145 3.715-4.128c0-3.907.013-9.415.013-11.095 0-6.306 4.062-6.372 5.143-6.372 1.081 0 6.408.066 6.408 6.372 0 2.693.02 5.389.02 8.083 0 .022.002.041.003.063.007 3.887.065 7.077.065 7.077h4.704s3.714.145 3.714-4.128c0-3.907.014-9.415.014-11.095 0-6.306 5.326-6.372 6.407-6.372 1.08 0 5.069.066 5.069 6.372 0 2.693.02 5.389.02 8.083 0 .022.002.041.003.063.007 3.887.065 7.077.065 7.077h4.624s3.715.145 3.715-4.128V46.94c.002-.004.004-.008.004-.013 0-5.531.164-7.552-.274-12.931M254.229 38.468c.011-4.404-2.892-7.516-7.088-7.597-4.468-.086-7.55 3.038-7.523 7.627.025 4.435 2.86 7.358 7.215 7.442 4.392.085 7.383-2.937 7.396-7.472m-6.15-14.446c12.057-.14 16.892 11.63 12.864 20.8-2.385 5.429-8.213 8.519-15.287 8.01-5.74-.412-10.536-2.683-12.84-8.294-2.258-5.497-1.82-10.909 2.094-15.601 3.087-3.7 7.352-4.942 13.17-4.915M152.265 34.983c.58-2.386 2.714-4.75 6.639-4.75 3.704 0 5.233 1.375 6.077 3.776.455 1.294.643 2.082-1.399 2.082-1.635 0-7.9-.006-10.294-.006-.77 0-1.28-.045-1.023-1.102m12.37 9.468c-.248.155-.777.48-1.54.925-3.818 2.646-9.627.113-10.504-3.518a8.329 8.329 0 0 1-.152-.83l15.244-.002.003-.003h1.692s3.728.158 3.728-4.116c0-1.031-.27-1.965-.688-3.17a1.075 1.075 0 0 0-.037-.118c-.06-.168-.13-.335-.195-.503l-.011-.032h-.001c-1.874-4.738-6.16-9.14-13.394-9.14-5.247 0-11.426 3.217-13.427 8.71-2.023 5.552-1.593 10.925 2.561 15.458 5.258 5.736 15.704 6.241 21.671 1.212.857-.722 1.522-1.588 2.108-2.513.89-1.405-.187-2.46-1.82-2.462l-5.078-.003s-.052.037-.16.105M142.109 49.761c-.836-3.732-2.114-3.743-4.493-3.432-1.862.245-3.331-.08-4.373-.966-1.084-.924-1.662-2.42-1.72-4.449v-6.04l-.029-.002c.001-8.415.017-15.304.017-15.304s.02-6.816-6.337-6.816c-1.683 0-2.174-.023-2.174-.023s.029 20.683.032 25.626c0 .051.004.1.004.15v.97c-.004.541-.003 1.198.045 1.973.335 5.46 3.68 9.703 8.226 10.969 3.073.856 6.101.458 9.194-.065a568.05 568.05 0 0 0 2.113-.368c-.118-.515-.35-1.526-.505-2.223M318.358 45.845c-4.355-.084-7.19-3.009-7.216-7.443-.026-4.59 3.055-7.713 7.524-7.626 4.196.08 6.628 3.192 6.616 7.597-.012 4.534-2.532 7.556-6.924 7.472m1.247-21.918c-5.818 0-9.612 1.215-12.697 4.914-3.915 4.692-4.353 10.104-2.096 15.601 2.305 5.612 6.63 7.882 12.369 8.295 3.298.236 6.992-1.159 8.642-2.926.63 2.749 3.002 2.899 3.002 2.899h4.7s-.122-7.376-.137-13.404c0-9.19-5.639-15.38-13.783-15.38M370.239 45.845c-4.356-.084-7.19-3.009-7.216-7.443-.027-4.59 3.055-7.713 7.523-7.626 4.196.08 6.628 3.192 6.617 7.597-.012 4.534-2.533 7.556-6.924 7.472m15.029-6.54c0-.358-.012-.71-.029-1.06.004-7.818.007-18.675.007-18.675s.021-6.815-6.337-6.815c-1.682 0-2.174-.024-2.174-.024l.008 12.173c-1.59-.635-3.354-.977-5.257-.977-5.819 0-9.612 1.215-12.698 4.914-3.915 4.692-4.353 10.104-2.096 15.601 2.305 5.612 6.63 7.882 12.37 8.295 3.297.236 6.991-1.159 8.64-2.926.63 2.749 3.003 2.899 3.003 2.899h4.7s-.121-7.376-.137-13.404M342.318 26.919c-1.683 0-2.174-.024-2.174-.024l.016 9.768c-.004 6.637-.016 9-.016 9s-.021 6.814 6.337 6.814c1.683 0 2.174.025 2.174.025l-.016-9.769c.004-6.637.016-8.999.016-8.999s.021-6.815-6.337-6.815"
                />
                <g transform="translate(338.916 12.587)">
                  <mask id="b" fill="#fff">
                    <use xlink:href="#a" />
                  </mask>
                  <path fill="#FFF" d="M6.937 10.572c1.683 0 2.174.024 2.174.024l-.016-2.01.013.007.003-1.669S9.13.109 2.773.109C1.091.109.6.084.6.084l.012 4.061.007.004c.11 1.445.882 6.423 6.32 6.423" mask="url(#b)" />
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      @if (!showForm()) {
        <div>
          <div class="welcome-inner-container">
            <div class="top-login-spacer-top"></div>
            <div class="top-login-spacer-top"></div>
            <div class="welcome-title">{{ 'new-user-welcome.title' | translate | async }}</div>
            <div class="top-login-spacer-bottom"></div>
            <div class="top-login-spacer-bottom"></div>
            <div class="top-login-spacer-bottom"></div>
            @if (commonError()) {
              <div class="dark-gray-text" style="margin: 0">{{ commonError() | translate | async }}</div>
            }
            <div style="height: 1vh; max-height: 10px"></div>
            <div class="text-field-spacer"></div>
            <div class="create-button-spacer"></div>
            @if (isUsedLinkError()) {
              <div class="button-container">
                <div style="padding: 1">
                  <div class="create-button-spacer"></div>
                  <button class="primarybutton" type="button" mat-button (click)="routeToLogin()">{{ 'login.login' | translate | async }}</button>
                  <div class="create-button-spacer"></div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (showForm()) {
        <div>
          <form novalidate>
            <div class="welcome-inner-container">
              <div class="top-login-spacer-top"></div>
              <div class="welcome-title">{{ 'new-user-welcome.title' | translate | async }}</div>
              <div class="welcome-title-bottom-spacer1"></div>
              <div class="welcome-title-bottom-spacer2"></div>
              <div class="dark-gray-text explanation-text" style="margin: 0">{{ 'new-user-welcome.start-text' | translate | async }}</div>
              <div style="height: 1vh; max-height: 10px"></div>
              @if (commonError()) {
                <div class="red-text common-error">{{ commonError() | translate | async }}</div>
              }
              <div>
                <div class="top-spacer"></div>
                <div class="text-field-header">{{ 'new-user-welcome.etunimi' | translate | async }}</div>
                <div class="text-field-spacer"></div>
                <div class="text-field-text">{{ etunimi().value() }}</div>
                <div class="text-field-spacer"></div>
                <div class="text-field-bottom-line"></div>
                <div class="top-spacer"></div>
              </div>
              <div>
                <div class="top-spacer"></div>
                <div class="text-field-header">{{ 'new-user-welcome.sukunimi' | translate | async }}</div>
                <div class="text-field-spacer"></div>
                <div class="text-field-text">{{ sukunimi().value() }}</div>
                <div class="text-field-spacer"></div>
                <div class="text-field-bottom-line"></div>
                <div class="top-spacer"></div>
              </div>
              <div>
                <div class="top-spacer"></div>
                <div class="text-field-header">{{ 'login.email' | translate | async }}</div>
                <div class="text-field-spacer"></div>
                <div class="text-field-text">{{ email().value() }}</div>
                <div class="text-field-spacer"></div>
                <div class="text-field-bottom-line"></div>
                <!-- <div class="top-spacer"></div> -->
              </div>
              <!-- <mat-form-field dense>
              <mat-label>{{ 'new-user-welcome.etunimi' | translate | async }}</mat-label>
              <input type="text" formControlName="etunimi"  matInput />
            </mat-form-field>
            <mat-form-field dense>
              <mat-label>{{ 'new-user-welcome.sukunimi' | translate | async }}</mat-label>
              <input type="text" formControlName="sukunimi"  matInput />
            </mat-form-field>
            <mat-form-field dense>
              <mat-label>{{ 'login.email' | translate | async }}</mat-label>
              <input type="email" name="email" formControlName="email"  autocomplete="email" matInput />
            </mat-form-field> -->
              <mat-form-field>
                <mat-label>{{ 'login.password' | translate | async }}</mat-label>
                <input [type]="hidePass ? 'password' : 'text'" [formField]="password" autocomplete="new-password" matInput />
                <button mat-icon-button matSuffix (click)="hidePass = !hidePass" [attr.aria-label]="'login.nayta-tai-piilota-salasana' | translate | async" [attr.aria-pressed]="hidePass">
                  <mat-icon>{{ hidePass ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                @if (virheet()?.required && (password().dirty() || password().touched())) {
                  <mat-error>{{ 'login.validation.password.required' | translate | async }}</mat-error>
                }
              </mat-form-field>
              <div class="welcome-errors">
                @if (virheet()?.number && !virheet()?.required && (password().dirty() || password().touched())) {
                  <div>{{ 'reset.validation.number' | translate | async }}</div>
                }
                @if (virheet()?.lettersmall && !virheet()?.required && (password().dirty() || password().touched())) {
                  <div>{{ 'reset.validation.lettersmall' | translate | async }}</div>
                }
                @if (virheet()?.letterbig && !virheet()?.required && (password().dirty() || password().touched())) {
                  <div>{{ 'reset.validation.letterbig' | translate | async }}</div>
                }
                @if (virheet()?.differentchars && !virheet()?.required && (password().dirty() || password().touched())) {
                  <div>{{ 'reset.validation.differentchars' | translate | async }}</div>
                }
                @if (virheet()?.min && !virheet()?.required && (password().dirty() || password().touched())) {
                  <div>{{ 'reset.validation.min' | translate | async }}</div>
                }
              </div>
              <div class="welcome-checkbox-spacer"></div>
              <!-- <div class="welcome-checkbox-container">
            <mat-checkbox color="primary" formControlName="agreeTerms"></mat-checkbox>
            <mat-label class="welcome-checkbox-label">{{ 'new-user-welcome.approve-user-terms-start' | translate | async }}
              <span class="light-blue-text link-like" (click)="openTerms()">{{ 'new-user-welcome.approve-user-terms-link' | translate | async }}</span>
            </mat-label>
            @if (agreeTerms?.errors?.required && (agreeTerms?.dirty || agreeTerms?.touched)) {
              <div class="welcome-errors">{{ 'new-user-welcome.approve-user-terms-error' | translate | async }}</div>
            }
          </div> -->
            </div>
            <div class="button-container">
              <div style="padding: 0">
                <div>
                  <div class="create-button-spacer"></div>
                  <button class="primarybutton" type="button" mat-button (click)="luoTili()">{{ 'new-user-welcome.create-account' | translate | async }}</button>
                  <div class="create-button-spacer"></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      }
    </div>

    <span class="disclaimer">© TILITOIMISTO LEMON TREE OY {{ year }}</span>
  </div>
</div>
